import { __rest, __awaiter } from '../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useState } from 'react';
import Typography from '../Typography/Typography.js';
import StyledButton from './Button.styles.js';

const Button = forwardRef((props, ref) => {
    const { children, fillType = "contained", color = "primary", disableColor, disabled: _disabled = false, onClick, startIcon, endIcon, size = "m", mSize } = props, restProps = __rest(props, ["children", "fillType", "color", "disableColor", "disabled", "onClick", "startIcon", "endIcon", "size", "mSize"]);
    const [isExecuting, setIsExecuting] = useState(false);
    const disable = _disabled || isExecuting;
    const _onClick = (e) => __awaiter(void 0, void 0, void 0, function* () {
        setIsExecuting(true);
        try {
            yield (onClick === null || onClick === void 0 ? void 0 : onClick(e));
        }
        finally {
            setIsExecuting(false);
        }
    });
    return (jsxs(StyledButton, Object.assign({}, restProps, { ref: ref, color: disable && disableColor ? disableColor : color, fillType: fillType, disabled: disable, onClick: _onClick, size: size }, { children: [startIcon, jsx(Typography, Object.assign({ size: size, mSize: mSize, weight: "medium" }, { children: children })), endIcon] })));
});

export { Button as default };
//# sourceMappingURL=Button.js.map
